import { ApolloClient, InMemoryCache } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';
import { apolloLink } from '../../../shared/data/apolloClient';

const suspectDetailsMediaApolloClient = new ApolloClient({
  link: apolloLink,
  cache: new InMemoryCache({
    typePolicies: {
      Suspect: {
        fields: {
          attachments: relayStylePagination(),
        },
      },
    },
  }),
});

export default suspectDetailsMediaApolloClient;
